import { ViewPage } from "@/components/ViewPage";
import type { View } from "@/features/views";
import { DashboardLegacyPage } from "@/pages/DashboardPage/DashboardLegacyPage";
import { FMSSubpage } from "@/pages/DashboardPage/fms/FMSSubpage";
import { ServiceManagerSubpage } from "@/pages/DashboardPage/sm/ServiceManagerSubpage";
import { TSSSubpage } from "@/pages/DashboardPage/tss/TSSSubpage";

const dashboardViews: Partial<Record<View, typeof FMSSubpage>> = {
    fmsAdvisor: FMSSubpage,
    technician: TSSSubpage,
    teamLead: TSSSubpage,
    serviceManager: ServiceManagerSubpage,
};

const DashboardPage = () => {
    return <ViewPage views={dashboardViews} fallback={DashboardLegacyPage} />;
};

export { DashboardPage };
